import { useState, useEffect } from 'react';

import * as taxApi from '../../../lib/api/taxbill';

//@mui
import { Box } from '@mui/material';
import SalesBillHistoryList from '../../../components/projectmng/bill_mng/SalesBillHistoryList';
import { useDispatch, useSelector } from 'react-redux';
import { listApprovalSalesTaxbills } from '../../../modules/approvalModule/issue-taxbills';

//-----------------------------------------------------

//-----------------------------------------------------

const SalesBillHistoryForApproval = ({ docuCd }) => {
  const [histories, setHistories] = useState([]);
  const dispatch = useDispatch();
  
  const { salesTaxbills } = useSelector(({ approvalModule }) => ({
    salesTaxbills: approvalModule.issueTaxbills.salesTaxbills,
  }));

  useEffect(() => {
    if (docuCd) {
      dispatch(listApprovalSalesTaxbills(docuCd));
    }
  }, [docuCd]);

  useEffect(() => {
    
    if (salesTaxbills) {
      
      setHistories(salesTaxbills);
      console.log(salesTaxbills);
    }
  }, [salesTaxbills]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        m: 1,
      }}
    >
      <SalesBillHistoryList history={histories} />
    </Box>
  );
};

export default SalesBillHistoryForApproval;
